<template>
	<div class='knd-paragraaf knd-paragraaf-twitter swiper-no-swiping'>
		<div ref='container'>
		</div>
	</div>
</template>

<script>

	import axios from 'axios';

	const vueObject = {
		props: ['data'],
		data: function() {
			return {
				addScriptPromise: 0
			}
		},
		mounted: function() {
			let id = this.getId(this.data.content);
			if(!id) return;

			Promise.resolve(window.twttr ? window.twttr : this.addPlatformScript('//platform.twitter.com/widgets.js'))
			.then(twttr => {
				twttr.widgets.createTweet(
					id,
					this.$refs.container,
					{
					theme: 'light'
					}
				);
			})
		},
		methods: {
			getId(url) {
				return url.substring(url.lastIndexOf('/') + 1);
			},

			addPlatformScript(src) {
				if (!this.addScriptPromise) {
						const s = document.createElement('script')
						s.setAttribute('src', src);
						document.body.appendChild(s);
						this.addScriptPromise = new Promise(resolve => {
								s.onload = () => {
										resolve(window.twttr)
								}
						})
				}
				return this.addScriptPromise;

			}
		}
	}

	export default vueObject;
</script>